import { allocationFetch } from "./allocationAuth";

// All calls here use the separate allocation-scoped token (see
// allocationAuth.js) — none of this touches the main app's auth store or
// shared request() client, by design.

export const getSeasonsWithSnapshot = () =>
  allocationFetch("/seasons/with-snapshot").catch(() => []);

export const getMyAllocation = (seasonId) =>
  allocationFetch(`/seasons/${seasonId}/my-allocation`).catch(() => ({ eligible: false }));

export const getSeasonLeaderboard = (seasonId, offset = 0, limit = 20) =>
  allocationFetch(`/seasons/${seasonId}/leaderboard?offset=${offset}&limit=${limit}`);

export const registerPayoutWallet = (seasonId, walletAddress) =>
  allocationFetch(`/seasons/${seasonId}/register-wallet`, {
    method: "POST",
    body: JSON.stringify({ walletAddress }),
  });
